import * as yup from 'yup';

export const adjustmentFreightSchema = yup.object().shape({
  invoice_id: yup.number().required('Invoice ID is required'),
  transaction_date: yup.string().required('Transaction date is required'),
  adj_freight: yup.number().min(1).label('Adjustment freight').required('Adjusted freight is required'),
  coa_ar_credit: yup.number().required('COA AR Credit is required'),
  coa_ar_credit_name: yup.string().optional(),
  coa_freight_debet: yup.number().required('COA Freight Debet is required'),
  coa_freight_debet_name: yup.string().optional(),
  employee_id: yup.number().required('Employee ID is required'),
  location_id: yup.number().required('Location ID is required'),
  customer_id: yup.number().required('Customer ID is required'),
});